const fileFormats = [
  "xlarge",
  "large",
  "medium",
  "small",
  "thumbnail"
];
const getBestImageFormat = (file) => {
  var _a, _b;
  if (!file)
    return;
  let imageFormat = void 0;
  for (const fileFormat of fileFormats) {
    if ((_a = file == null ? void 0 : file.formats) == null ? void 0 : _a[fileFormat]) {
      imageFormat = (_b = file == null ? void 0 : file.formats) == null ? void 0 : _b[fileFormat];
      break;
    }
  }
  return imageFormat;
};
const getImageFormat = (options) => {
  var _a, _b;
  if (!options || !options.file)
    return;
  const requestedFormat = (_a = options.file.formats) == null ? void 0 : _a[options.format || ""];
  if (requestedFormat == null ? void 0 : requestedFormat.url)
    return requestedFormat.url;
  return options.waterfall ? (_b = getBestImageFormat(options.file)) == null ? void 0 : _b.url : options.file.url;
};
const getImageWidth = (options) => {
  var _a, _b;
  if (!options || !options.file)
    return;
  const requestedFormat = (_a = options.file.formats) == null ? void 0 : _a[options.format || ""];
  if (requestedFormat == null ? void 0 : requestedFormat.width)
    return requestedFormat.width;
  return options.waterfall ? (_b = getBestImageFormat(options.file)) == null ? void 0 : _b.width : options.file.width;
};
const getImageHeight = (options) => {
  var _a, _b;
  if (!options || !options.file)
    return;
  const requestedFormat = (_a = options.file.formats) == null ? void 0 : _a[options.format || ""];
  if (requestedFormat == null ? void 0 : requestedFormat.height)
    return requestedFormat.height;
  return options.waterfall ? (_b = getBestImageFormat(options.file)) == null ? void 0 : _b.height : options.file.height;
};
const fileIsSvg = (file) => {
  if (!file)
    return false;
  return file.mime === "image/svg+xml";
};
const fileIsImage = (file) => {
  if (!file)
    return false;
  return file.mime.startsWith("image/");
};
const fileIsVideo = (file) => {
  if (!file)
    return false;
  return file.mime.startsWith("video/");
};

export { fileFormats, fileIsImage, fileIsSvg, fileIsVideo, getBestImageFormat, getImageFormat, getImageHeight, getImageWidth };
